import React from "react";
import { useLoadScript } from "@react-google-maps/api";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng,
} from "use-places-autocomplete";

const SearchComponent = ({ onLocationSelected }) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: ["places"],
  });

  if (!isLoaded) return <div>Loading...</div>;
  return <PlacesAutocomplete onLocationSelected={onLocationSelected} />;
};

const PlacesAutocomplete = ({ onLocationSelected }) => {
  const {
    ready,
    value,
    suggestions: { status, data },
    setValue,
    clearSuggestions,
  } = usePlacesAutocomplete();

  const handleSelect = async (address) => {
    setValue(address, false);
    clearSuggestions();

    try {
      const results = await getGeocode({ address });
      const { lat, lng } = await getLatLng(results[0]);
      onLocationSelected({ lat, lng });
    } catch (error) {
      console.error("Error: ", error);
    }
  };

  return (
    <div style={{ position: 'relative', padding: '0 16px' }}>
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        disabled={!ready}
        placeholder="Search for a location..."
        style={{
          width: '100%',
          padding: '9px 13px',
          background: '#111827',
          border: '1px solid rgba(255,255,255,0.12)',
          borderRadius: '9px',
          color: '#f1f5f9',
          fontSize: '0.875rem',
          fontFamily: 'Inter, sans-serif',
          outline: 'none',
          boxSizing: 'border-box',
        }}
      />
      {status === "OK" && (
        <ul style={{
          position: 'absolute',
          zIndex: 20,
          left: 16,
          right: 16,
          background: '#161b27',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '10px',
          marginTop: '4px',
          boxShadow: '0 8px 24px rgba(0,0,0,0.5)',
          listStyle: 'none',
          padding: 0,
          overflow: 'hidden',
        }}>
          {data.map(({ place_id, description }) => (
            <li
              key={place_id}
              onClick={() => handleSelect(description)}
              style={{
                padding: '10px 14px',
                color: '#cbd5e1',
                fontSize: '0.85rem',
                cursor: 'pointer',
                borderBottom: '1px solid rgba(255,255,255,0.05)',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'rgba(16,185,129,0.08)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              {description}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default SearchComponent;

